/* eslint-disable no-console */
export default (text, ...rest) =>
  console.log("3778 covid-bot", "|", text, ...rest);
